import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

import PropTypes from 'prop-types';
import Modal from './Modal';

export default function CancelInvoice({ invoiceId }) {
  const [show, setShow] = useState(false);

  return (
    <>
      <Button
        onClick={() => setShow(true)}
        bsStyle="danger"
      >
        Cancel
      </Button>
      <Modal invoiceId={invoiceId} show={show} onHide={() => setShow(false)} />
    </>
  );
}

CancelInvoice.propTypes = {
  invoiceId: PropTypes.number.isRequired,
};
